import { createSelector } from "reselect";
import { AppState } from "src/shared/interfaces/State.interface";

const selectProject = (state: AppState) => state.project;

export const getProjects = () => createSelector(selectProject, (state) => state.projects);
export const getCurrentProject = () => createSelector(selectProject, (state) => state.currentProject);
export const getProjectsTotal = () => createSelector(selectProject, (state) => state.projectsTotal);
export const getFilter = () => createSelector(selectProject, (state) => state.filter);
